import { AppSearchBadge, AppSearchBox } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useInquirySearchTokens } from '@inquiries/-components/SearchArea/components/InquirySearchBox/hooks/useInquirySearchTokens'
import { useInquiryDivisionMap } from '@inquiries/-components/SearchArea/hooks/useInquiryDivisionMap'
import { useSearchBoxHandlers } from '@/hooks/useSearchBoxHandlers'
import { inquirySearchBadgeConfig } from './search-badge-config'

interface InquirySearchBoxProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  label?: string
  tooltipContent?: string
}

/**
 * InquirySearchBox - 引き合い検索ボックス
 *
 * 検索条件をパースしてバッジ形式で表示します。
 */
export function InquirySearchBox({
  value,
  onChange,
  placeholder = '例: プロジェクト名 キーワード',
  className,
  label,
  tooltipContent,
}: InquirySearchBoxProps) {
  const divisionMap = useInquiryDivisionMap()
  const tokens = useInquirySearchTokens(value, divisionMap)
  const { inputValue, setInputValue, inputRef, removeToken, handleKeyDown } = useSearchBoxHandlers(
    value,
    onChange,
    tokens,
  )

  return (
    <AppSearchBox
      value={inputValue}
      onChange={setInputValue}
      onKeyDown={handleKeyDown}
      inputRef={inputRef}
      label={label}
      tooltipContent={tooltipContent}
      placeholder={tokens.length === 0 ? placeholder : ''}
      className={className}
    >
      {tokens.map((token, index) => (
        <AppSearchBadge
          key={`${token.raw}-${index}`}
          token={token}
          onRemove={removeToken}
          config={inquirySearchBadgeConfig}
        />
      ))}
    </AppSearchBox>
  )
}
